import React from 'react';
import { FilledButton } from '../components/common/Button';
import useRouting from '../hooks/useRouting';
import useCurrentUser from '../hooks/useCurrentUser';

const NotFound404Page: React.FC = () => {
  const { currentUser } = useCurrentUser();
  const { goToMyProjects, goToDashboard } = useRouting();

  return (
    <div className="bg-background2 dark:bg-dark-background2 min-h-screen flex items-center justify-center py-4 px-4">
      <div className="bg-background1 dark:bg-dark-background1 rounded-lg shadow-lg p-8 text-center max-w-md">
        <h1 className="mb-4 text-primary dark:text-secondary">
          404 - Page Not Found
        </h1>
        <p className="text-text2 dark:text-text2 mb-6">
          We are sorry. The page you are looking for does not exist.
        </p>
        <div className="flex justify-center">
          {currentUser ? (
            <FilledButton onClick={goToMyProjects}>Go to My Projects</FilledButton>
          ) : (
            <FilledButton onClick={goToDashboard}>Go to Dashboard</FilledButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFound404Page;
